<div
  #sidenav
  class="secondary"
>
  <div class="items">
    <router-outlet
      name="aside-secondary"
      (activate)="onSecondaryActivate()"
      (deactivate)="onSecondaryDeactivate()"
    />
  </div>
  <procure-resize-handler
    placement="left"
    (mousedown)="startResizing($event)"
  />
  <procure-sidenav-toggle-button
    placement="left"
    [isExpanded]="sidenavService.isExpanded()"
    (click)="toggle()"
  />
</div>
